import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../../../store/slices/auth.slice";
import { all_routes } from "../../../../router/all_routes";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";
import { AppDispatch, RootState } from "../../../../store/store";
import { handleApiError } from "../../../../utils/errorHandler";
import { Image, message } from "antd";
interface LoginForm {
  email: string;
  password: string;
  rememberMe: boolean;
}

const Login2 = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { error, loading } = useSelector((state: RootState) => state.auth);

  const [formData, setFormData] = useState<LoginForm>({
    email: "",
    password: "",
    rememberMe: false
  });

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // CSS stilleri
  const footerStyles = `
    .hover-link {
      transition: all 0.3s ease;
      font-size: 0.875rem;
    }
    .hover-link:hover {
      color: #007bff !important;
      transform: translateY(-1px);
    }
    .hover-link i {
      opacity: 0.7;
      transition: opacity 0.3s ease;
    }
    .hover-link:hover i {
      opacity: 1;
    }
  `;

 const handleSubmit = (e: React.FormEvent) => {
  // Bu çok önemli! Form gönderimini kesinlikle engellenmeli
  e.preventDefault();
  
  // Form içeriğini kontrol edin
  if (!formData.email || !formData.password) {
    message.error("Lütfen tüm alanları doldurunuz");
    return;
  }
  
  // Asenkron işlemi ayrı bir fonksiyona çıkarın
  doLogin();
};

// Asenkron işlemi ayrı fonksiyona ayırın
const doLogin = async () => {
  try {
    const result = await dispatch(login({ 
      email: formData.email, 
      password: formData.password,
      isMobile:false
    })).unwrap();
    
    if (result.tokens.accessToken) {
      navigate(routes.adminDashboard);
    }
  } catch (error) {
    if (typeof error === 'string') {
      message.error(error);
    } else if (error && typeof error === 'object') {
      handleApiError(error);
    } else {
      message.error("Beklenmeyen bir hata oluştu");
    }
  }
};

  const togglePasswordVisibility = () => {
    setPasswordVisibility(prev => ({
      password: !prev.password
    }));
  };

  return (
    <>
      <style>{footerStyles}</style>
      <div className="container-fuild">
        <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
        <div className="row">
          <div className="col-lg-5">
            <div className="d-lg-block align-items-center justify-content-center d-none flex-wrap vh-100">
              <div>
                <ImageWithBasePath src="assets/img/bg/authentication-bg-03.svg" alt="Img" />
              </div>
            </div>
          </div>
          <div className="col-lg-7 col-md-12 col-sm-12">
            <div className="row justify-content-center align-items-center vh-100 flex-wrap">
              <div className="col-md-7 mx-auto">
                <form onSubmit={handleSubmit}>
                  <div className="d-flex flex-column justify-content-center min-vh-100" style={{paddingTop: "2rem", paddingRight: "1.5rem",paddingLeft: "1.5rem",paddingBottom: "2rem"}}>
                  
                    <div className="flex-grow-0">
                      <div className="text-center mb-3">
                      <div className="mx-auto text-center mb-3" style={{width: "60%"}}>
                      <ImageWithBasePath src="assets/img/dinox-light.png" alt="Logo"/>
                    </div>
                        <h2 className="mb-2">Giriş Yap</h2>
                        <p className="mb-0">Lütfen giriş bilgilerinizi giriniz</p>
                      </div>
                      <div className="mb-2">
                        <label className="form-label">Email Adresi</label>
                        <div className="input-group">
                          <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            className="form-control border-end-0"
                          />
                          <span className="input-group-text border-start-0">
                            <i className="ti ti-mail" />
                          </span>
                        </div>
                      </div>
                      <div className="mb-2">
                        <label className="form-label">Şifre</label>
                        <div className="pass-group">
                          <input
                            type={passwordVisibility.password ? "text" : "password"}
                            name="password"
                            value={formData.password}
                            onChange={handleInputChange}
                            className="pass-input form-control"
                          />
                          <span
                            className={`ti toggle-passwords ${passwordVisibility.password ? "ti-eye" : "ti-eye-off"}`}
                            onClick={togglePasswordVisibility}
                          />
                        </div>
                      </div>
                      <div className="d-flex align-items-center justify-content-end mb-2">
                        <div className="text-end">
                          <Link to={routes.forgotPassword2} className="link-danger">
                            Şifremi Unuttum
                          </Link>
                        </div>
                      </div>
                      <div className="mb-2">
                        <button 
                          type="submit" // "button" yerine "submit" kullanın
                          className="btn btn-primary w-100"
                          disabled={loading}
                        >
                          {loading ? 'Giriş Yapılıyor...' : 'Giriş Yap'}
                        </button>
                      </div>
                      <div className="mb-2">
                        <a href={routes.login3} target="_blank">
                        <button 
                          type="button"
                          className="btn btn-outline-primary register-btn w-100" 
                          // onClick={() => window.open("https://dinox.app/create-company", "_blank")}
                        >
                          Kayıt Ol
                        </button>
                        </a>
                      </div>
                      {/* <div className="text-center">
                        <h6 className="fw-normal text-dark mb-0">
                          Hesabınız yok mu?
                          <Link to={routes.register2} className="hover-a">
                            {" "}
                            Hesap Oluştur
                          </Link>
                        </h6>
                      </div>
                      <div className="login-or">
                        <span className="span-or">Veya</span>
                      </div>
                      <div className="mt-2">
                        <div className="d-flex align-items-center justify-content-center flex-wrap">
                          <div className="text-center me-2 flex-fill">
                            <Link to="#" className="br-10 p-2 btn btn-info d-flex align-items-center justify-content-center">
                              <ImageWithBasePath className="img-fluid m-1" src="assets/img/icons/facebook-logo.svg" alt="Facebook" />
                            </Link>
                          </div>
                          <div className="text-center me-2 flex-fill">
                            <Link to="#" className="br-10 p-2 btn btn-outline-light border d-flex align-items-center justify-content-center">
                              <ImageWithBasePath className="img-fluid m-1" src="assets/img/icons/google-logo.svg" alt="Google" />
                            </Link>
                          </div>
                          <div className="text-center flex-fill">
                            <Link to="#" className="bg-dark br-10 p-2 btn btn-dark d-flex align-items-center justify-content-center">
                              <ImageWithBasePath className="img-fluid m-1" src="assets/img/icons/apple-logo.svg" alt="Apple" />
                            </Link>
                          </div>
                        </div>
                      </div> */}
                    </div>
                    <div className="mt-4">
                      {/* Footer Links */}
                      <div className="row mb-2">
                        <div className="col-12">
                          <div className="d-flex flex-wrap justify-content-center align-items-center gap-2 mb-2">
                            <Link to="https://dinox.com.tr/" target="_blank" className="text-muted text-decoration-none small hover-link">
                              <i className="ti ti-info-circle me-1"></i>
                              Hakkımızda
                            </Link>
                            <span className="text-muted d-none d-md-inline">|</span>
                            <Link to="https://dinox.com.tr/kvkk-politikasi" target="_blank" className="text-muted text-decoration-none small hover-link">
                              <i className="ti ti-shield-check me-1"></i>
                              KVKK
                            </Link>
                            <span className="text-muted d-none d-md-inline">|</span>
                            <Link to="https://dinox.com.tr/iptal-iade-kosullari" target="_blank" className="text-muted text-decoration-none small hover-link">
                              <i className="ti ti-truck-delivery me-1"></i>
                              İptal & İade
                            </Link>
                          </div>
                          <div className="d-flex flex-wrap justify-content-center align-items-center gap-2 mb-2">
                            <Link to="https://dinox.com.tr/gizlilik-politikasi" target="_blank" className="text-muted text-decoration-none small hover-link">
                              <i className="ti ti-lock me-1"></i>
                              Gizlilik
                            </Link>
                            <span className="text-muted d-none d-md-inline">|</span>
                            <Link to="https://dinox.com.tr/mesafeli-satis-sozlesmesi" target="_blank" className="text-muted text-decoration-none small hover-link">
                              <i className="ti ti-file-text me-1"></i>
                              Mesafeli Satış
                            </Link>
                          </div>
                        </div>
                      </div>
                      
                      {/* Copyright */}
                      <div className="text-center">
                        <hr className="my-2 opacity-25" />
                        <p className="mb-2 text-gray-9 small">
                          <i className="ti ti-copyright me-1"></i>
                          © Dinox - {new Date().getFullYear()} | Tüm hakları saklıdır
                        </p>
                        <div className="d-flex justify-content-center align-items-center gap-2 mb-2">
                          <img src="assets/img/mastercardlogo.png" alt="Mastercard" width={50} />
                          <img src="assets/img/visalogo.png" alt="Visa" width={50} />
                          <img src="assets/img/iyzicologo.png" alt="Iyzico" width={120} />
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Login2;
